(() => {
  const settings = window.vstar_review_settings;
  if (!settings) return;

  // Use Trustoo's own review pages to calculate the full store + product average.
  settings.reviews_per_page_number = 100;
  let switched = false;
  let attempts = 0;
  const keepPosition = (target, savedTop) => {
    target.click();
    const restore = () => {
      if (Math.abs(window.scrollY - savedTop) > 100) window.scrollTo({ top: savedTop, behavior: 'instant' });
    };
    window.requestAnimationFrame(restore);
    window.setTimeout(restore, 150);
  };

  const start = () => {
  const timer = window.setInterval(() => {
    if (++attempts > 120) {
      window.clearInterval(timer);
      return;
    }

    const widget = document.querySelector('#trustoo-widget-wrapper #vstar-reviews');
    if (!widget) return;

    const productCount = Number(widget.querySelector('[data-product-reviews]')?.textContent.trim());
    const storeCount = Number(widget.querySelector('[data-shop-reviews]')?.textContent.trim());
    const productReviews = [...widget.querySelectorAll('#reviews-body .tt-review-list .list-review')];
    if (!productCount || !storeCount || productReviews.length !== productCount) return;

    if (!switched) {
      const storeTab = widget.querySelector('.tt-tabs-list .tt-tab[index="2"]');
      if (!storeTab) return;
      switched = true;
      keepPosition(storeTab, window.scrollY);
      return;
    }

    const storeReviews = [...widget.querySelectorAll('#reviews-body .tt-shop-reviews .list-review')];
    if (storeReviews.length !== storeCount) return;

    const ratings = [...productReviews, ...storeReviews].map(review => Number(review.getAttribute('data-rating')));
    if (ratings.some(rating => !Number.isFinite(rating) || rating < 1 || rating > 5)) return;

    const total = ratings.length;
    const average = ratings.reduce((sum, rating) => sum + rating, 0) / total;

    const applyCombinedRating = () => {
      const point = widget.querySelector('#reviews-head .big-point');
      const count = widget.querySelector('#reviews-head .reviews-num');
      if (!point || !count) return;

      if (point.textContent !== average.toFixed(1)) point.textContent = average.toFixed(1);
      if (count.textContent !== total + ' Customer Reviews') count.textContent = total + ' Customer Reviews';

      widget.querySelectorAll('#reviews-head .star-raw').forEach(row => {
        const star = Number(row.querySelector('.number')?.textContent);
        const quantity = ratings.filter(rating => Math.round(rating) === star).length;
        const percent = quantity / total * 100;
        const bar = row.querySelector('.star-range');
        const number = row.querySelector('.star-num');
        if (bar) bar.style.background = 'linear-gradient(to right, var(--star-color) 0%, var(--star-color) ' + percent + '%, var(--nostar-color) ' + percent + '%, var(--nostar-color) 100%)';
        if (number) number.textContent = quantity;
      });

      let stars = widget.querySelector('#reviews-head .combined-rating-stars');
      if (!stars) {
        stars = document.createElement('span');
        stars.className = 'combined-rating-stars';
        stars.textContent = '★★★★★';
        widget.querySelector('#reviews-head .product-rating .vstar-star')?.insertAdjacentElement('afterend', stars);
      }
      stars.setAttribute('role', 'img');
      stars.setAttribute('aria-label', average.toFixed(1) + ' out of 5 stars');
      stars.style.setProperty('--star-fill', average / 5 * 100 + '%');
      widget.classList.add('combined-rating-ready');
    };

    const productTab = widget.querySelector('.tt-tabs-list .tt-tab[index="0"]');
    if (productTab) keepPosition(productTab, window.scrollY);
    window.setTimeout(applyCombinedRating, 100);
    widget.querySelector('.tt-tabs-list')?.addEventListener('click', () => window.setTimeout(applyCombinedRating, 100));
    window.clearInterval(timer);
  }, 150);
  };

  const observeWidget = () => {
    const widget = document.querySelector('#trustoo-widget-wrapper #vstar-reviews');
    if (!widget) return false;
    const viewport = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) {
        viewport.disconnect();
        start();
      }
    }, { rootMargin: '600px 0px' });
    viewport.observe(widget);
    return true;
  };

  if (!observeWidget()) {
    const waitForWidget = new MutationObserver(() => {
      if (observeWidget()) waitForWidget.disconnect();
    });
    waitForWidget.observe(document.body, { childList: true, subtree: true });
  }
})();
